import classNames from 'classnames'
import styles from './FlexRow.css'

export const FlexRowTitle = props => {
  const {
    className,
    children
  } = props

  const fullClassNames = classNames(
    styles.flexRowTitle,
    { [className]: !!className }
  )

  return (
    <div className={fullClassNames}>
      {children}
    </div>
  )
}

const FlexRow = props => {
  const {
    className,
    children
  } = props

  const fullClassNames = classNames(
    styles.flexRow,
    { [className]: !!className }
  )

  return (
    <div className={fullClassNames}>
      {children}
    </div>
  )
}

export default FlexRow
